import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import { SettingService } from "../../../services/setting-service";

export const Settingedit = (props) => {
  const [submitloading, setSubmitLoading] = useState(true);

  const { settingID } = useParams();

  useEffect(() => {
    SettingSearchID();
  }, []);

  const [settinginfo, setSettingInfo] = useState({
    key: "",
    type: "",
    value: "",
  });

  const SettingSearchID = async () => {
    try {
      const result = await SettingService.settingDetailsID(settingID);

      const info = {};

      const settingdata = result;

      info.key = settingdata.key;
      info.type = settingdata.type;
      info.value = settingdata.value;

      setSettingInfo(info);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await SettingService.settingUpdate(settingID, values.value);

      setSubmitLoading(true);
      notify("Setting successfully updated");
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Setting</h6>
            </div>
            <div className="ms-panel ms-panel-fh">
              <div className="ms-panel-body">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    key: settinginfo.key,
                    type: settinginfo.type,
                    value: settinginfo.value,
                  }}
                  validationSchema={Yup.object().shape({
                    // name: Yup.string()
                    //   .required("Required")
                    //   .min(5, "name must have at least 5 characters")
                    //   .max(10, "name must have less than 10 characters"),
                    value: Yup.string().required("Required"),
                  })}
                  onSubmit={onSubmitForm}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    touched,
                    values,
                    submitForm,
                    isValid,
                    setFieldValue,
                  }) => (
                    <div>
                      <div className="form-row">
                        <div className="col-md-12 mb-6">
                          <label htmlFor="validationCustom18">Key</label>
                          <div className="input-group">
                            <input
                              name="key"
                              type="text"
                              className="form-control"
                              id="keyid"
                              placeholder="Key"
                              required
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.key}
                              readOnly
                            />
                          </div>
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {touched.key && errors.key}
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12 mb-6">
                          <label htmlFor="validationCustom18">Type</label>
                          <div className="input-group">
                            <input
                              name="type"
                              className="form-control"
                              id="typeid"
                              required
                              type="text"
                              placeholder="type"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.type}
                              readOnly
                            />
                          </div>
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {touched.key && errors.key}
                          </div>
                        </div>
                      </div>

                      <div>
                        {settinginfo.type === "TEXT" ? (
                          <div>
                            {" "}
                            <div className="form-row">
                              <div className="col-md-12 mb-6">
                                <label htmlFor="validationCustom18">
                                  Value
                                </label>
                                <div className="input-group">
                                  <input
                                    name="value"
                                    type="text"
                                    className="form-control"
                                    id="valueid"
                                    placeholder="Enter String"
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.value}
                                  />
                                </div>
                                <div style={{ color: "red", fontSize: "12px" }}>
                                  {touched.value && errors.value}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : settinginfo.type === "NUMBER" ? (
                          <div>
                            <div className="form-row">
                              <div className="col-md-12 mb-6">
                                <label htmlFor="validationCustom18">
                                  Value
                                </label>
                                <div className="input-group">
                                  <input
                                    name="value"
                                    type="number"
                                    className="form-control"
                                    id="valueid"
                                    placeholder="Enter Number"
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.value}
                                  />
                                </div>
                                <div style={{ color: "red", fontSize: "12px" }}>
                                  {touched.value && errors.value}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            {" "}
                            <div className="form-row">
                              <label htmlFor="validationCustom18">Value</label>
                              <div className="col-md-12 mb-6">
                                <label className="ms-switch">
                                  <input type="checkbox" />{" "}
                                  <span className="ms-switch-slider round" />
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-md-2" hidden={submitloading}>
                        <div className="spinner spinner-7">
                          <div className="bounce1" />
                          <div className="bounce2" />
                          <div className="bounce3" />
                        </div>
                      </div>

                      <div
                        className="form-row"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <button
                          type="button"
                          className="btn btn-primary shadow-none"
                          onClick={submitForm}
                        >
                          Save and Update
                        </button>
                      </div>
                    </div>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settingedit;
